import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.css']
})
export class EmptyResultComponent implements OnInit {

  @Input() title = '';
  @Input() subTitle = '';
  @Input() image = null;

  defaultImage = 'assets/img/bg/empty.jpg';

  constructor() { }

  ngOnInit(): void {
  }

}
